export type primitive =
  | string
  | number
  | bigint
  | boolean
  | symbol
  | undefined
  | null

export function isNotPrimitive<T extends object>(value: any): value is T {
  return value && typeof value === 'object'
}

export function isPrimitive(value: any): value is primitive {
  return !(typeof value === 'object' && value)
}

export function checkSignificantValue(value: unknown) {
  if (!value) {
    return false
  }

  if (Array.isArray(value)) {
    return value.every(checkSignificantValue)
  }
  if (typeof value === 'object') {
    return Object.values(value).every(checkSignificantValue)
  }

  return true
}
export const getSignificantObject = (value = {}) => {
  if (!value) {
    return value
  }
  return Object.fromEntries(
    Object.entries(value).filter(([key, value]) => value != undefined),
  )
}

export const checkThreshold = (
  index: number,
  length: number,
  limit: number,
  threshold: number,
) => {
  const prevSelectionLastIndex = length - limit
  const thresholdIndex = prevSelectionLastIndex + limit * threshold
  return index + 1 >= thresholdIndex
}
